import { render, staticRenderFns } from "./slecete_rule_json.vue?vue&type=template&id=445e41f8&scoped=true&"
import script from "./slecete_rule_json.vue?vue&type=script&lang=js&"
export * from "./slecete_rule_json.vue?vue&type=script&lang=js&"
import style0 from "./slecete_rule_json.vue?vue&type=style&index=0&id=445e41f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445e41f8",
  null
  
)

export default component.exports